import { render, staticRenderFns } from "./relContentDialog.vue?vue&type=template&id=179800d4"
import script from "./relContentDialog.vue?vue&type=script&lang=js"
export * from "./relContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports